import LogoEmblem from "@/components/LogoEmblem";

export default function Logo({ size = 40 }) {
  return <LogoEmblem size={size} />;
}
